import React from 'react'

const Price = () => {
  return (
    <section>
        <div className="container">
            <div className="row mb-5">
                <div className="col-md-12">
                    <h1 className="site_h1 my-4">House Plans</h1>
                    <div className="house_plan_img">
                        <img src="images/house_plans.jpg" className="w-100" alt='housePrice' />
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Price
